import { getTailwindColor } from '@/utils/colors';
import clsx from 'clsx';
import { LabelsType, ProductType } from '../types';

type Props = {
    products: ProductType[];
    chosenProduct: ProductType | null;
    onClick: (product: ProductType) => void;
    getLabel: (key: keyof LabelsType, replacements?: Record<string, string | number>) => string;
};

export const Products = ({ products, chosenProduct, onClick, getLabel }: Props) => {
    const gridClass = products.length === 1 ? 'r-grid-cols-1' : products.length === 3 ? 'r-grid-cols-3' : 'r-grid-cols-2';

    return (
        <div className={clsx('r-mb-4 r-flex r-flex-row r-gap-4 md:r-mb-0 md:r-grid', gridClass)}>
            {products.map(product => (
                <button
                    onClick={() => onClick(product)}
                    className={clsx(
                        'r-flex r-flex-shrink-0 r-flex-col r-justify-between r-gap-6',
                        'r-border r-border-neutral-400 r-ring r-ring-transparent r-transition-all r-duration-100',
                        'hover:r-border-primary-200 md:hover:r-ring-[2px] md:hover:r-ring-primary-200',
                        'r-rounded-2xl r-p-3',
                        products.length === 1 ? 'r-w-full' : 'r-w-56 md:r-w-auto',
                        { 'r-min-h-[6.875rem]': products.length === 3 },
                        { 'r-border-primary-200 md:r-ring-[2px] md:r-ring-primary-200': chosenProduct?.code === product.code }
                    )}
                    key={product.code}
                >
                    <h3
                        className={clsx(
                            'r-text-left',
                            chosenProduct?.code === product.code ? 'r-font-medium r-text-primary-200' : 'r-text-neutral-900'
                        )}
                    >
                        {product.name}
                    </h3>
                    <p className="r-flex r-flex-row r-items-center r-gap-2 r-text-sm r-text-neutral-900">
                        <span>
                            {product.interest.type === 'FIXED' ? getLabel('fixed') : getLabel('variable')} {getLabel('rate')}:
                        </span>
                        <span className={clsx('r-rounded-full r-px-2 r-py-[2px] r-font-bold', getTailwindColor('accent8', 'bg'))}>
                            {product.interest.rate}%
                        </span>
                    </p>
                </button>
            ))}
            {products.length > 1 && <div className="r-w-0.5 r-flex-shrink-0 md:r-hidden" aria-hidden="true" />}
        </div>
    );
};
